<template>
	<FormCard>
		<h3>Assessment Details</h3>
		<div class="flex">
			<ag-grid-vue
				class="ag-theme-alpine"
				style="width: 100%; min-height: 350px"
				:rowData="rowData"
				:columnDefs="columnDefs"
				:defaultColDef="{ flex: 1, resizable: true }"
				@grid-ready="onGridReady"
			>
			</ag-grid-vue>
		</div>
	</FormCard>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue"
import { AgGridVue } from "ag-grid-vue3"
import { ApiClient, VersionClient } from "../../entities/NSwagGenerated"

//Define props to receive assessmentId
const props = defineProps({
	assessmentId: {
		type: String,
		required: true,
	},
})

//API client
const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const versionClient = new VersionClient(import.meta.env.VITE_API_URL?.toString())

const rowData = ref([{ detail: "Loading...", value: "" }])

//Column definitions
const columnDefs = ref([
	{ field: "detail", headerName: "Detail" },
	{ field: "value", headerName: "Value" },
])

//Fetch data when mounted
onMounted(async () => {
	try {
		const res = await apiClient.getSingleAssessmentById(props.assessmentId)
		const version = await versionClient.getVersion()

		// Map API response to grid format
		rowData.value = [
			{ detail: "Project Name", value: res.subProject?.project?.projectName ?? "" },
			{ detail: "Sub Project Name", value: res.subProject?.subProjectName ?? "" },
			{ detail: "Assessment Name", value: res.assessmentName ?? "" },
			{ detail: "Generated On", value: new Date().toLocaleString() },
			{ detail: "Eco-Design Version", value: version?.version ?? "" },
		]
	} catch (error) {
		console.error("Failed to load assessment details:", error)
	}
})

//Grid API reference
const gridApi = ref(null)
function onGridReady(params: any) {
	gridApi.value = params.api
}

//Expose API for export testing
const getGridApi = () => gridApi.value
defineExpose({ getGridApi })
</script>

<style>
.ag-theme-alpine {
	height: 100%;
	width: 100%;
}
</style>
